"use client";

import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";

type Provider = "google" | "apple";

export function EmailInUseNotice({ provider, email }: { provider: Provider; email: string }) {
  const t = useTranslations("auth");
  const accent = provider === "google" ? "emailInUseGoogleHintAccent" : "emailInUseAppleHintAccent";
  const body = provider === "google" ? "emailInUseGoogleHintBody" : "emailInUseAppleHintBody";
  const cta = provider === "google" ? "emailInUseGoogleCta" : "emailInUseAppleCta";
  return (
    <div className="flex w-full flex-col items-center gap-3 rounded-2xl border border-red-400/30 bg-red-500/5 px-4 py-4 text-center">
      <p className="text-sm text-ink">
        <span className="font-medium text-red-400">{t(`errors.${accent}`)}</span>{" "}
        <span className="text-ink-mute">{t(`errors.${body}`)}</span>
      </p>
      <Link
        href={`/forgot-password?email=${encodeURIComponent(email)}`}
        className="inline-flex h-10 items-center justify-center rounded-full border border-line bg-surface px-5 text-sm font-medium text-ink transition-colors hover:bg-surface-mute"
      >
        {t(`errors.${cta}`)}
      </Link>
    </div>
  );
}
